import React from 'react';
import classNames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';

export default React.createClass({
  render() {
    const { active, tracked, columnId, loading, row } = this.props;

    if (loading) return <PlaceholderRow />;

    const { item } = row;

    const itemNumber = item.numberAdjusted;
    const title = item.title || 'Item';
    const text = `${itemNumber} - ${title}`;
    const hasContent = item.cells[columnId] ? item.cells[columnId].text : null;

    const classes = classNames(
      {
        active: active,
        tracked: tracked,
        'fullscreen-row-content-indicator': hasContent,
      },
      'fullscreen-row-wrapper',
    );

    return (
      <div className={classes} onClick={this._onRowSelect}>
        <div className="fullscreen-row-text-wrapper">
          <div className="loaded">{text}</div>
        </div>
        {hasContent ? <Icon name="paragraph" /> : null}
      </div>
    );
  },

  _onRowSelect() {
    const { onRowSelect, rowId } = this.props;
    onRowSelect(rowId);
  },
});

const PlaceholderRow = () => {
  return (
    <div className="fullscreen-row-wrapper">
      <div className="fullscreen-row-text-wrapper loading-animation">
        <div className="loading" />
      </div>
    </div>
  );
};
